import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const ArrowDownDiagonal: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2071 3.79289C20.5976 4.18342 20.5976 4.81658 20.2071 5.20711L6.91421 18.5H15.75C16.3023 18.5 16.75 18.9477 16.75 19.5C16.75 20.0523 16.3023 20.5 15.75 20.5H4.5C3.94772 20.5 3.5 20.0523 3.5 19.5V8.25C3.5 7.69772 3.94772 7.25 4.5 7.25C5.05228 7.25 5.5 7.69772 5.5 8.25V17.0858L18.7929 3.79289C19.1834 3.40237 19.8166 3.40237 20.2071 3.79289Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowDownDiagonal;
